<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <el-form ref="projectForm" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="测评表名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="初始分数" prop="init_score">
        <el-input type="number" v-model="form.init_score"></el-input>
      </el-form-item>
      <el-form-item label="测评表备注" prop="comment">
        <el-input type="textarea" v-model="form.comment"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      projectName: "",
      form: {
        name: "",
        comment: "",
      },
      rules: {
        name: [{ required: true, message: "请输入测评表名称", trigger: "blur" }],
        init_score:[{ required: true, message: "请输入初始分数", trigger: "blur" }]
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    submitForm() {
      let that = this;
      this.$refs["projectForm"].validate((valid) => {
        if (valid) {
          that.dialogVisible = false;
          that.$emit("saveValue", that.form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleShow(title, data) {
      this.dialogVisible = true;
      this.title = title;
      if (data) {
        this.form = data;
      } else {
        this.form = {
          name: "",
          comment: "",
        };
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
